import React from 'react';
import styled from 'styled-components';
import { CAPanelBody } from './ca-panel';
import { materialPresets } from '../../data/common/materials';
import { Row, Col } from 'antd';
import { CAButton } from './ca-button';
import { CAVariableInput } from './ca-variable-input';
import { InvertedImage } from '../../utils/inverted-image';
import { TagFurnitureType, TagMaterialType, TagColor } from '../../data/common/tags';
import { models } from '../../data/common/models';

import ItemTypeChairSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-28.svg';
import ItemTypeHighchairSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-29.svg';
import ItemTypeToiletSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-30.svg';
import ItemTypeWashwareSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-31.svg';
import ItemTypeCupboardSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-32.svg';
import ItemTypeKitchenwareSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-33.svg';
import ItemTypeTableSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-34.svg';
import ItemTypeBathwareSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-35.svg';
import ItemTypeShelfSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-36.svg';
import ItemTypeSofaSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-37.svg';
import ItemTypeBedSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-38.svg';
import ItemTypeDecorSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-39.svg';
import ItemTypeHangerSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-43.svg';
import ItemTypeDoorSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-45.svg';
import ItemTypeWindowSVG from '../../images/common-app/icons/ICONS_COMMON_SVG-46.svg';

export const MaterialPreviewWrapper = styled.div`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  position: relative;
  cursor: pointer;
  filter: drop-shadow(0px 1px 2px #cccccc);

  img {
    transition: all .1s ease;
    min-width: 50px;
    min-height: 50px;
    animation: fadeIn 1s linear .1s 1 both alternate;
  }

  &:hover {
    img {
      transform: scale(1.2);
    }
  }

  ${p => p.selected && `
    &:after {
      position: absolute;
      top: 10%;
      right: 10%;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #000;
      content: '';
      z-index: 1;
    }
  `}
`;

const MaterialPreviewBall = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: ${p => p.size}px;
  height: ${p => p.size}px;
  border-radius: 50%;
  background-color: ${p => p.color || 'transparent'};
  z-index: -1;
  transform: translateX(-50%) translateY(-50%);
  pointer-events: none;
`;

export const MaterialPreview = (props) => {
  return (
    <MaterialPreviewWrapper
      selected={props.selected}
    >
      {props.previewColor && <MaterialPreviewBall color={props.previewColor} size={(props.previewSize || 170) / 2} />}
      <img {...props} />
    </MaterialPreviewWrapper>
  );
};

export class CAFilters extends React.Component {
  render() {
    const {
      libraryFilters,
      onChange
    } = this.props;

    return (
      <CAPanelBody margin="10px 10px">
        <CAVariableInput
          inputType="expand-box"
          name="Item"
          icon={(libraryFilters.itemType || []).length > 0 ? 'fas fa-fw fa-circle' : null}
        >
          <Row gutter={5} style={{ marginBottom: 10 }}>
            {([
              { icon: ItemTypeDoorSVG, tag: TagFurnitureType.door },
              { icon: ItemTypeWindowSVG, tag: TagFurnitureType.window },
              { icon: ItemTypeChairSVG, tag: TagFurnitureType.chair },
              { icon: ItemTypeHighchairSVG, tag: TagFurnitureType.kitchenChair },
              { icon: ItemTypeToiletSVG, tag: TagFurnitureType.toiletWare },
              { icon: ItemTypeWashwareSVG, tag: TagFurnitureType.washWare },
              { icon: ItemTypeCupboardSVG, tag: TagFurnitureType.cupboard },
              { icon: ItemTypeKitchenwareSVG, tag: TagFurnitureType.cookingWare },
              { icon: ItemTypeTableSVG, tag: TagFurnitureType.table },
              { icon: ItemTypeBathwareSVG, tag: TagFurnitureType.bathWare },
              { icon: ItemTypeShelfSVG, tag: TagFurnitureType.shelf },
              { icon: ItemTypeSofaSVG, tag: TagFurnitureType.sofa },
              { icon: ItemTypeBedSVG, tag: TagFurnitureType.bed },
              { icon: ItemTypeDecorSVG, tag: TagFurnitureType.plants },
              { icon: ItemTypeHangerSVG, tag: TagFurnitureType.hanger },
            ]).map(({ icon, tag }) => {
              const isActive = (libraryFilters.itemType || []).includes(tag);

              return (
                <Col span={12}>
                  <InvertedImage
                    src={icon}
                    style={{
                      filter: [isActive ? '' : 'invert(100%)', 'drop-shadow(0px 1px 2px rgba(0, 0, 0, .1))'].join(' '),
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      const newFilters = {
                        ...libraryFilters,
                        itemType: isActive ?
                          libraryFilters.itemType.filter(i => i !== tag) :
                          (libraryFilters.itemType || []).concat([ tag ])
                      };

                      onChange(newFilters);
                    }}
                  />
                </Col>
              );
            })}
          </Row>
        </CAVariableInput>
        <CAVariableInput
          inputType="expand-box"
          name="Material"
          icon={(libraryFilters.materials || []).length > 0 ? 'fas fa-fw fa-circle' : null}
        >
          <Row gutter={5} style={{ marginBottom: 10 }}>
            {([
              { preview: 'wood-glossy', tag: TagMaterialType.wood },
              { preview: 'plastic-basic', tag: TagMaterialType.plastic },
              { preview: 'red-paint', tag: TagMaterialType.paint },
              { preview: 'metal', tag: TagMaterialType.metal },
              { preview: 'glass', tag: TagMaterialType.glass },
            ]).map(({ preview, tag }) => {
              const isActive = (libraryFilters.materials || []).includes(tag);
              const material = materialPresets[preview];

              return (
                <Col span={8}>
                  <MaterialPreview
                    previewColor={material.color}
                    previewSize={40}
                    src={material.previewUrl}
                    width="100%"
                    selected={isActive}
                    onClick={() => {
                      const newFilters = {
                        ...libraryFilters,
                        materials: isActive ?
                          libraryFilters.materials.filter(i => i !== tag) :
                          (libraryFilters.materials || []).concat([ tag ])
                      };

                      onChange(newFilters);
                    }}
                  />
                </Col>
              );
            })}
          </Row>
        </CAVariableInput>
        <CAVariableInput
          inputType="expand-box"
          name="Color"
          icon={libraryFilters.color ? 'fas fa-fw fa-circle' : null}
        >
          <CAVariableInput
            span={24}
            inputType="color"
            inputProps={{
              allowClear: true
            }}
            value={libraryFilters.colorHex}
            onChange={(value) => {
              if (!value) {
                const newFilters = {
                  ...libraryFilters,
                  colorHex: null,
                  color: null
                };

                return onChange(newFilters);
              }

              const { hex, hsl } = value;
              let colorName;
              const { h, s, l } = hsl;

              if (l === 0) {
                colorName = TagColor.black;
              } else if (l <= .2) {
                colorName = TagColor.gray;
              } else if (l === 1) {
                colorName = TagColor.white;
              } else {
                if (h < 0) {
                  colorName = TagColor.white;
                } else if (h < 20) {
                  colorName = TagColor.red;
                } else if (h < 50) {
                  colorName = TagColor.orange;
                } else if (h < 90) {
                  colorName = TagColor.yellow;
                } else if (h < 180) {
                  colorName = TagColor.green;
                } else if (h < 210) {
                  colorName = TagColor.cyan;
                } else if (h < 260) {
                  colorName = TagColor.blue;
                } else if (h < 300) {
                  colorName = TagColor.violet;
                } else if (h < 310) {
                  colorName = TagColor.pink;
                } else {
                  colorName = TagColor.red;
                }
              }

              const newFilters = {
                ...libraryFilters,
                colorHex: hex,
                color: colorName
              };

              onChange(newFilters);
            }}
          />
        </CAVariableInput>
        <CAVariableInput
          inputType="expand-box"
          name="Size"
          icon={libraryFilters.sizeLimit && libraryFilters.sizeLimit < 9 ? 'fas fa-fw fa-circle' : null}
        >
          <div style={{ width: '80%', margin: '0 auto' }}>
            <CAVariableInput
              span={24}
              inputType="slider"
              value={libraryFilters.sizeLimit || 9}
              before={
                <div style={{ transform: 'scale(.7)' }}>
                  <i className="fas fa-fw fa-cube" />
                </div>
              }
              after={
                <div style={{ transform: 'scale(1.2)' }}>
                  <i className="fas fa-fw fa-cube" />
                </div>
              }
              inputProps={{
                min: 1,
                max: 9,
                step: .5
              }}
              wrapperProps={{
                style: {
                  marginBottom: 10
                }
              }}
              onChange={(value) => {
                const newFilters = {
                  ...libraryFilters,
                  sizeLimit: value
                };

                onChange(newFilters);
              }}
            />
          </div>
        </CAVariableInput>
        <CAVariableInput
          inputType="expand-box"
          name="Price"
          icon={libraryFilters.priceLimit && libraryFilters.priceLimit < 1000 ? 'fas fa-fw fa-circle' : null}
        >
          <div style={{ width: '80%', margin: '0 auto' }}>
            <CAVariableInput
              span={24}
              inputType="slider"
              value={libraryFilters.priceLimit || 1000}
              before={
                <div style={{ transform: 'scale(1)' }}>
                  <i className="fal fa-fw fa-euro-sign" />
                </div>
              }
              after={
                <div style={{ transform: 'scale(1.2)' }}>
                  <i className="fal fa-fw fa-euro-sign" />
                </div>
              }
              inputProps={{
                min: 10,
                max: 1000,
                step: 5,
                tipFormatter: (value) => value === 1000 ? `€${value},00 or above` : `Up to €${value},00`
              }}
              wrapperProps={{
                style: {
                  marginBottom: 10
                }
              }}
              onChange={(value) => {
                const newFilters = {
                  ...libraryFilters,
                  priceLimit: value
                };

                onChange(newFilters);
              }}
            />
          </div>
        </CAVariableInput>
        <CAVariableInput
          inputType="expand-box"
          name="Place"
          icon={libraryFilters.location ? 'fas fa-fw fa-circle' : null}
        >
          <CAVariableInput
            span={24}
            value={libraryFilters.location}
            wrapperProps={{
              style: {
                marginBottom: 10
              }
            }}
            onBlur={(value) => {
              const newFilters = {
                ...libraryFilters,
                location: value
              };

              onChange(newFilters);
            }}
            autoSuggestions={Object.keys(models).map(id => (models[id].details || {}).shippingFrom)}
            inputProps={{
              placeholder: 'Search ...'
            }}
          />
        </CAVariableInput>
        <CAVariableInput
          inputType="expand-box"
          name="Designer / Studio"
          icon={libraryFilters.designer ? 'fas fa-fw fa-circle' : null}
        >
        <CAVariableInput
            span={24}
            value={libraryFilters.designer}
            wrapperProps={{
              style: {
                marginBottom: 10
              }
            }}
            onBlur={(value) => {
              const newFilters = {
                ...libraryFilters,
                designer: value
              };

              onChange(newFilters);
            }}
            autoSuggestions={Object.keys(models).reduce((all, id) => {
              const details = (models[id].details || {});

              return all.concat([ details.owner, details.designer ].filter(Boolean));
            }, [])}
            inputProps={{
              placeholder: 'Search ...'
            }}
          />
        </CAVariableInput>
      </CAPanelBody>
    );
  }
}